<template>
  <div class="movie-vertical-scroll-bar movie-details-wrapper">
      <!-- top返回 -->
      <MovieGoBack :text="text"></MovieGoBack>

      <!-- 电影内容详情 -->
       <div class="movie-details-content">
           <!-- 卡片 -->
            <div class="movie-box acea-row movie-detail-card">
                <img src="https://img.daeyes.com.cn:8081/uploads/images/Film/4377fab5-f81d-42ec-b001-73135da9dd33/20210208090807.jpg"/>
                <div class="detail">
                    <div class="h page-text-ellipsis-nowrap">你好，李焕英</div>
                    <p>奇幻/动作/冒险</p>
                    <p>120分钟</p>
                    <div class="page-text-center time">2021-02-12</div>
                    <p class="score">评分：9.3</p>
                </div>
            </div>
            <div class="movie-box page-relative movie-detail-synopsis">
                <h1>简介</h1>
                <div :class="{content:true,'change-height':!checked}">
                    2001年的某一天，刚刚考上大学的贾晓玲（贾玲 饰）经历了人生中的一次大起大落。一心想要成为母亲骄傲的她却因母亲突遭严重意外，而悲痛万分。在贾晓玲情绪崩溃的状态下，竟意外的回到了 1981 年，并与年轻的母亲李焕英（张小斐 饰）相遇，二人形影不离，宛如闺蜜。与此同时，也结识了一群天真善良的好朋友。晓玲以为来到了这片广阔天地，她可以凭借自己超前的思维，让母亲大有作为，但结果却让晓玲感到意外......
                </div>
                <span class="page-absolute arrow" @click="open()">
                    <span v-show="checked">︿</span>
                    <span v-show="!checked">﹀</span>
                </span>

            </div>


            <!-- 演员 剧照 -->
            <div class="movie-detail-stills">
                <ul class="acea-row row-middle row-around tab">
                    <li v-for='(item,ind) in photoTab' 
                       :key='ind'
                       @click='checkTab(item)'
                       :class='{checkLi:item.checked}'
                       >{{item.name}}</li>
                </ul>
                <div class="movie-horizontal-scroll-bar stills-wrapper" ref='bar'>
                    <dl class="page-inline-block stills-single" v-for='(val, index) in photoList' :key='index'>
                        <dt>
                            <img :src='val.img'/>
                        </dt>
                        <dd>
                            <p class="page-text-center actor">{{val.actor}}</p>
                            <p class="page-text-center page-text-ellipsis-nowrap role">{{val.role}}</p>
                        </dd>
                    </dl>
                </div>
            </div>       
       </div>

      <!-- 立即购票 -->
      <MovieBottomButton :text="'立即购票'"  :goTo="{path:'/chooseCinema'}"></MovieBottomButton>
  </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";

export default {
    name:"MovieDetails",
    components:{
        MovieGoBack,
        MovieBottomButton
    },

    data:function(){
        return {
            text:'你好，李焕英',
            checked: false,
            photoTab:[{name:'演员',checked:true},{name:'剧照',checked:false}],
            photoList:[],
            photoData:[
                {
                    type:'演员',
                    list:[
                        {
                            actor:'贾玲',
                            img:'//p1.meituan.net/movie/21be0ac9b672915807a9d303b11bed9e171181.jpg@160w_224h_80q_1e_1c',
                            role:'导演'
                        },{
                            actor:'贾玲',
                            img:'//p1.meituan.net/movie/21be0ac9b672915807a9d303b11bed9e171181.jpg@160w_224h_80q_1e_1c',
                            role:'饰 贾晓玲'
                        },{
                            actor:'张小斐',
                            img:'//p1.meituan.net/moviemachine/343d5e99af59d269a74f541f91c1f96e167598.jpg@160w_224h_80q_1e_1c',
                            role:'饰 李焕英'
                        },{
                            actor:'沈腾',
                            img:'//p1.meituan.net/moviemachine/798344498dd685ecac377f6c1f684567193741.jpg@160w_224h_80q_1e_1c',
                            role:'饰 沈光林'
                        },{
                            actor:'陈赫',
                            img:'//p1.meituan.net/movie/961d75fd7042e45ed39be87f40284a9937407.jpg@160w_224h_80q_1e_1c',
                            role:'饰 冷特'
                        },{
                            actor:'刘佳',
                            img:'//p0.meituan.net/movie/bc7d7066cce19eb600212ddcb503462f169244.jpg@160w_224h_80q_1e_1c',
                            role:'饰 李焕英（中年时期）'
                        },{
                            actor:'丁嘉丽',
                            img:'//p0.meituan.net/movie/c5ec524007315b1347d2dfb3a67d32d9120246.jpg@160w_224h_80q_1e_1c',
                            role:'饰 梅姨'
                        }
                    ]
                },{
                    type:'剧照',
                    list:[
                        {
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        },{
                            img:'//p0.meituan.net/movie/afd3c374050b440800afaf66b08b8348792642.jpg@420w_279h_80q_1e_1c'
                        }
                    ]
                }
            ]
        }
    },
    methods:{
        open:function(){//简介开关
            this.checked = !this.checked;
        },
        checkTab:function(val){//tab开关
            this.photoTab.forEach((item,ind) => {
                item.checked = false;
            })
            val.checked = true;

            this.photoData.forEach((item, ind) => {
                if(val.name == item.type) {
                    this.photoList = [...item.list]
                }
            })

            // 切换tab之后滚动条到0
            this.$nextTick(() => {
                this.$refs.bar.scrollTo(0,0);
            })
        }
    },
    mounted:function(){
        this.photoTab.forEach((item,ind) => {
             if(item.checked) {
                 this.photoData.forEach((val,key) => {
                     if (item.name == val.type) {
                         this.photoList = [...val.list];
                     }
                 })
             }
        })
    }
}
</script>

<style scoped>
.movie-detail-card{
    height:2.9rem;
    padding:.2rem .3rem;
}
.movie-detail-card img{
    width:1.91rem;
    height:2.37rem;
    box-shadow: 0px 4px 9px 0px rgba(255, 12, 70, 0.29);
    border-radius:.15rem;
    flex-shrink: 0;
}
.detail{
    flex:1;
    margin-left:.34rem;
    overflow:hidden;
}
.detail .h{
    width:100%;
    font-size:.4rem;
    font-weight: 500;
    color: #333333;
    line-height: .8rem;
}
.detail p{
    font-size:.27rem;
    color: #666666;
    padding-bottom:.05rem;
}
.detail .time{
    width:1.7rem;
    height:.3rem;
    background:#00A0E9;
    border-radius:.16rem;
    line-height:.37rem;
    color:#ffff;
    font-size:.25rem;
    margin-bottom:.05rem;
}
.detail .score{
    font-weight: 500;
    color: #FF0C46;
    font-size:.3rem;
}
.movie-detail-synopsis{
    padding:.2rem .3rem .4rem;
    background:#fff;
    border-bottom:.2rem solid #f5f3f3;
}
.movie-detail-synopsis h1{
    font-size: .32rem;
    font-weight: 520;
    color: #333333;
    line-height: .32rem;
    margin-bottom:.2rem;
}
.movie-detail-synopsis .content{
    color: #999999;;
    font-size:.22rem;
    font-weight: 500;
    line-height:.32rem;
}
.change-height{
    height:1rem;
    overflow:hidden;
}
.movie-detail-synopsis .arrow {
    bottom:.03rem;
    left:50%;
    transform: translate(-50%);
    color:rgba(255, 11, 70, 1);
    font-size:.14rem;
    font-weight:800;
}
.movie-detail-stills{
    box-sizing: border-box;
    background:#fff;
    padding:.2rem .3rem;
    overflow:hidden;
}
.movie-detail-stills .tab{
    color:#666666;
    font-size:.28rem;
}
.tab li{
    padding-bottom:.1rem;
}
.checkLi{
    color:#FF0C47;
    position:relative;
}
.checkLi::after{
    content:'';
    position: absolute;
    bottom:0;
    left:.05rem;
    width:.4rem;
    height:.05rem;
    border-radius:.03rem;
    background:linear-gradient(-90deg, #FF0B46 0%, #FFAF98 100%);
}
.stills-wrapper{
    margin-top:.2rem;
}
.stills-single{
    margin-right:.2rem;
    width:1.4rem;
}
.stills-single dt img{
    width:1.4rem;
    height:1.9rem;
    border-radius:.15rem;
}
.stills-single .actor{
    font-size:.28rem;
    line-height:.3rem;
}
.stills-single .role{
    color:#666;
    font-size:.24rem;
}
</style>